import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { TrendingUp, Trophy } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { getLeagueConfig } from './league-tokens';

export function RankingCard({ position, total, points, league }) {
  const { t } = useTranslation('achievements');
  const leagueName = league ? getLeagueConfig(league).name : '';

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.2, ease: 'easeOut' }}
    >
      <Card className="border-slate-200/60 bg-gradient-to-br from-indigo-50/50 to-white">
        <CardContent className="p-5">
          <div className="flex items-start justify-between gap-2">
            <div className="space-y-1">
              <p className="text-xs font-semibold uppercase tracking-wider text-indigo-600">
                {leagueName ? t('rankingInLeague', { league: leagueName }) : t('myRanking')}
              </p>
              <p className="text-3xl font-bold tracking-tight text-slate-900">
                #{position?.toLocaleString() ?? '—'}
              </p>
              {total != null && (
                <p className="text-xs text-slate-500">
                  {t('playersInRange', { total: total.toLocaleString() })}
                </p>
              )}
            </div>
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500 to-blue-600 text-white shadow-sm">
              <Trophy className="h-5 w-5" />
            </div>
          </div>

          {points != null && (
            <div className="mt-4 flex items-center gap-2 rounded-lg bg-white/60 p-3 text-sm">
              <TrendingUp className="h-4 w-4 text-emerald-500" />
              <span className="font-semibold text-slate-900 tabular-nums">
                {points.toLocaleString()}
              </span>
              <span className="text-slate-500">{t('totalPointsShort')}</span>
            </div>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
}

export default RankingCard;
